<template>
    <modal width="20rem" @close="handleClose">
        <template #header>
            <div class="text-red-500">
                Remove Chart from Chart Books
            </div>
        </template>
        <template #body>
            <p class="paragraph">Are you sure you want to remove the link to <strong>{{ symbol }}</strong>?</p>
            <p class="paragraph">All changes saved to this chart will remain and you can add this chart again later.</p>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-red-ghost inline-flex mx-1" @click="handleClose">Cancel</div>
                <div class="btn btn-sm btn-red inline-flex mx-1" @click="remove">Remove Chart</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue';

// Define props
const props = defineProps({
    chart: {
        type: Object,
        required: true
    }
});

// Define emits
const emit = defineEmits(['close', 'delete']);

// Reactive state
const symbol = ref(props.chart.symbol_display || props.chart.symbol);

// Methods
const remove = () => {
    emit('delete', props.chart);
    emit('close');
};

const handleClose = () => {
    emit('close');
};
</script>
